import { useMutation } from '@tanstack/react-query';
import { deleteLegalAgreementDocument } from '../../api/portalServices';

export const useDeleteDocument = () => {
  return useMutation({
    mutationFn: deleteLegalAgreementDocument,
  });
};
